import { call, put, all, takeEvery } from "redux-saga/effects";

import {
  GET_MESSAGING_CONVERSATION_LIST,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST,
  SEND_MESSAGING_CONVERSATION_MESSAGE,
  UPDATE_MESSAGING_CONVERSATION,
  CREATE_MESSAGING_CONVERSATION,
  GET_MESSAGING_CHANNEL_LIST,
  START_MESSAGING_CONVERSATION_MESSAGE,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT,
  MARK_MESSAGING_CONVERSATION_READ,
  MARK_MESSAGING_CONVERSATION_UNREAD,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD,
  GET_MESSAGING_CONVERSATION_DATA,
  CLOSE_MESSAGING_CONVERSATION,
} from "./actionType";

import {
  getMessagingConversationListSuccess,
  getMessagingConversationListFailure,
  searchMessagingConversationMessageListSuccess,
  searchMessagingConversationMessageListFailure,
  sendMessagingConversationMessageSuccess,
  sendMessagingConversationMessageFailure,
  updateMessagingConversationSuccess,
  updateMessagingConversationFailure,
  createMessagingConversationSuccess,
  createMessagingConversationFailure,
  getMessagingChannelListSuccess,
  getMessagingChannelListFailure,
  startMessagingConversationMessageSuccess,
  startMessagingConversationMessageFailure,
  searchMessagingConversationTemplateSuccess,
  searchMessagingConversationTemplateFailure,
  removeMessagingConversationParticipantSuccess,
  removeMessagingConversationParticipantFailure,
  markMessagingConversationReadSuccess,
  markMessagingConversationReadFailure,
  markMessagingConversationUnreadSuccess,
  markMessagingConversationUnreadFailure,
  markMessagingConversationMessageReadSuccess,
  markMessagingConversationMessageReadFailure,
  markMessagingConversationMessageUnreadSuccess,
  markMessagingConversationMessageUnreadFailure,
  getMessagingConversationDataSuccess,
  getMessagingConversationDataFailure,
  closeMessagingConversationSuccess,
  closeMessagingConversationFailure,
} from "./action";

import {
  getMessagingConversationListApi,
  searchMessagingConversationMessageListApi,
  sendMessagingConversationMessageApi,
  updateMessagingConversationApi,
  createMessagingConversationApi,
  getMessagingChannelListApi,
  startMessagingConversationMessageApi,
  searchMessagingConversationTemplateApi,
  removeMessagingConversationParticipantApi,
  markMessagingConversationReadApi,
  markMessagingConversationUnreadApi,
  markMessagingConversationMessageReadApi,
  markMessagingConversationMessageUnreadApi,
  getMessagingConversationDataApi,
  closeMessagingConversationApi,
} from "../../helpers/fakebackend_helper";

//GET_MESSAGING_CONVERSATION_LIST
function* getMessagingConversationList({ payload }) {
  try {
    const response = yield call(getMessagingConversationListApi, payload);
    yield put(getMessagingConversationListSuccess(response));
  } catch (error) {
    yield put(getMessagingConversationListFailure(error));
  }
}
// Watcher Saga
function* watchMessagingService() {
  yield takeEvery(
    GET_MESSAGING_CONVERSATION_LIST,
    getMessagingConversationList
  );
}
//SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST
function* searchMessagingConversationMessageList({ payload }) {
  try {
    const response = yield call(
      searchMessagingConversationMessageListApi,
      payload
    );
    yield put(searchMessagingConversationMessageListSuccess(response));
  } catch (error) {
    yield put(searchMessagingConversationMessageListFailure(error));
  }
}
// Watcher Saga
function* watchSearchMessagingConversationMessageList() {
  yield takeEvery(
    SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST,
    searchMessagingConversationMessageList
  );
}
//SEND_MESSAGING_CONVERSATION_MESSAGE
function* sendMessagingConversationMessage({ payload }) {
  try {
    const response = yield call(sendMessagingConversationMessageApi, payload);
    yield put(sendMessagingConversationMessageSuccess(response));
  } catch (error) {
    yield put(sendMessagingConversationMessageFailure(error));
  }
}
// Watcher Saga
function* watchSendMessagingConversationMessage() {
  yield takeEvery(
    SEND_MESSAGING_CONVERSATION_MESSAGE,
    sendMessagingConversationMessage
  );
}
//UPDATE_MESSAGING_CONVERSATION
function* updateMessagingConversation({ payload }) {
  try {
    const response = yield call(updateMessagingConversationApi, payload);
    yield put(updateMessagingConversationSuccess(response));
  } catch (error) {
    yield put(updateMessagingConversationFailure(error));
  }
}

// Watcher Saga
function* watchUpdateMessagingConversation() {
  yield takeEvery(UPDATE_MESSAGING_CONVERSATION, updateMessagingConversation);
}

//CREATE_MESSAGING_CONVERSATION
function* createMessagingConversation({ payload }) {
  try {
    const response = yield call(createMessagingConversationApi, payload);
    yield put(createMessagingConversationSuccess(response));
  } catch (error) {
    yield put(createMessagingConversationFailure(error));
  }
}
// Watcher Saga
function* watchCreateMessagingConversation() {
  yield takeEvery(CREATE_MESSAGING_CONVERSATION, createMessagingConversation);
}
//GET_MESSAGING_CHANNEL_LIST
function* getMessagingChannelList({ payload }) {
  try {
    const response = yield call(getMessagingChannelListApi, payload);
    yield put(getMessagingChannelListSuccess(response));
  } catch (error) {
    yield put(getMessagingChannelListFailure(error));
  }
}
// Watcher Saga
function* watchGetMessagingChannelList() {
  yield takeEvery(GET_MESSAGING_CHANNEL_LIST, getMessagingChannelList);
}
//START_MESSAGING_CONVERSATION_MESSAGE
function* startMessagingConversationMessage({ payload }) {
  try {
    const response = yield call(startMessagingConversationMessageApi, payload);
    yield put(startMessagingConversationMessageSuccess(response));
  } catch (error) {
    yield put(startMessagingConversationMessageFailure(error));
  }
}
// Watcher Saga
function* watchStartMessagingConversationMessage() {
  yield takeEvery(
    START_MESSAGING_CONVERSATION_MESSAGE,
    startMessagingConversationMessage
  );
}
//SEARCH_MESSAGING_CONVERSATION_TEMPLATE
function* searchMessagingConversationTemplate({ payload }) {
  try {
    const response = yield call(
      searchMessagingConversationTemplateApi,
      payload
    );
    yield put(searchMessagingConversationTemplateSuccess(response));
  } catch (error) {
    yield put(searchMessagingConversationTemplateFailure(error));
  }
}
// Watcher Saga
function* watchSearchMessagingConversationTemplate() {
  yield takeEvery(
    SEARCH_MESSAGING_CONVERSATION_TEMPLATE,
    searchMessagingConversationTemplate
  );
}
//REMOVE_MESSAGING_CONVERSATION_PARTICIPANT
function* removeMessagingConversationParticipant({ payload }) {
  try {
    const response = yield call(
      removeMessagingConversationParticipantApi,
      payload
    );
    yield put(removeMessagingConversationParticipantSuccess(response));
  } catch (error) {
    yield put(removeMessagingConversationParticipantFailure(error));
  }
}
// Watcher Saga
function* watchRemoveMessagingConversationParticipant() {
  yield takeEvery(
    REMOVE_MESSAGING_CONVERSATION_PARTICIPANT,
    removeMessagingConversationParticipant
  );
}
//MARK_MESSAGING_CONVERSATION_READ
function* markMessagingConversationRead({ payload }) {
  try {
    const response = yield call(markMessagingConversationReadApi, payload);
    yield put(markMessagingConversationReadSuccess(response));
  } catch (error) {
    yield put(markMessagingConversationReadFailure(error));
  }
}
// Watcher Saga
function* watchMarkMessagingConversationRead() {
  yield takeEvery(
    MARK_MESSAGING_CONVERSATION_READ,
    markMessagingConversationRead
  );
}
//MARK_MESSAGING_CONVERSATION_UNREAD
function* markMessagingConversationUnread({ payload }) {
  try {
    const response = yield call(markMessagingConversationUnreadApi, payload);
    yield put(markMessagingConversationUnreadSuccess(response));
  } catch (error) {
    yield put(markMessagingConversationUnreadFailure(error));
  }
}
// Watcher Saga
function* watchMarkMessagingConversationUnread() {
  yield takeEvery(
    MARK_MESSAGING_CONVERSATION_UNREAD,
    markMessagingConversationUnread
  );
}
//MARK_MESSAGING_CONVERSATION_MESSAGE_READ
function* markMessagingConversationMessageRead({ payload }) {
  try {
    const response = yield call(
      markMessagingConversationMessageReadApi,
      payload
    );
    yield put(markMessagingConversationMessageReadSuccess(response));
  } catch (error) {
    yield put(markMessagingConversationMessageReadFailure(error));
  }
}
// Watcher Saga
function* watchMarkMessagingConversationMessageRead() {
  yield takeEvery(
    MARK_MESSAGING_CONVERSATION_MESSAGE_READ,
    markMessagingConversationMessageRead
  );
}
//MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD
function* markMessagingConversationMessageUnread({ payload }) {
  try {
    const response = yield call(
      markMessagingConversationMessageUnreadApi,
      payload
    );
    yield put(markMessagingConversationMessageUnreadSuccess(response));
  } catch (error) {
    yield put(markMessagingConversationMessageUnreadFailure(error));
  }
}
// Watcher Saga
function* watchMarkMessagingConversationMessageUnread() {
  yield takeEvery(
    MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD,
    markMessagingConversationMessageUnread
  );
}

//GET_MESSAGING_CONVERSATION_DATA
function* getMessagingConversationData({ payload }) {
  console.log("🚀 getMessagingConversationData payload:", payload);
  try {
    const response = yield call(getMessagingConversationDataApi, payload);
    yield put(getMessagingConversationDataSuccess(response));
  } catch (error) {
    yield put(getMessagingConversationDataFailure(error));
  }
}
// Watcher Saga
function* watchGetMessagingConversationData() {
  yield takeEvery(
    GET_MESSAGING_CONVERSATION_DATA,
    getMessagingConversationData
  );
}
//CLOSE_MESSAGING_CONVERSATION
function* closeMessagingConversation({ payload }) {
  try {
    const response = yield call(closeMessagingConversationApi, payload);
    yield put(closeMessagingConversationSuccess(response));
  } catch (error) {
    yield put(closeMessagingConversationFailure(error));
  }
}
// Watcher Saga
function* watchCloseMessagingConversation() {
  yield takeEvery(CLOSE_MESSAGING_CONVERSATION, closeMessagingConversation);
}

// Root Saga
export default function* MessagingServiceSaga() {
  yield all([
    watchMessagingService(),
    watchSearchMessagingConversationMessageList(),
    watchSendMessagingConversationMessage(),
    watchUpdateMessagingConversation(),
    watchCreateMessagingConversation(),
    watchGetMessagingChannelList(),
    watchStartMessagingConversationMessage(),
    watchSearchMessagingConversationTemplate(),
    watchRemoveMessagingConversationParticipant(),
    watchMarkMessagingConversationRead(),
    watchMarkMessagingConversationUnread(),
    watchMarkMessagingConversationMessageRead(),
    watchMarkMessagingConversationMessageUnread(),
    watchGetMessagingConversationData(),
    watchCloseMessagingConversation(),
  ]);
}
